import { render, staticRenderFns } from "./safe-folder.vue?vue&type=template&id=1c7bc373&scoped=true&"
import script from "./safe-folder.vue?vue&type=script&lang=ts&"
export * from "./safe-folder.vue?vue&type=script&lang=ts&"
import style0 from "./safe-folder.vue?vue&type=style&index=0&id=1c7bc373&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7bc373",
  null
  
)

export default component.exports